import React, {Component} from 'react';
import ActionsBox from './actions'
import Details from './details'

export default class Homeright extends Component
{
constructor(props)
{
  super(props);
this.changeslink=this.changeslink.bind(this);
this.changerlink=this.changerlink.bind(this);
this.changestep=this.changestep.bind(this);
this.changestatus=this.changestatus.bind(this);
this.viewRep=this.viewRep.bind(this);
}

changeslink(slink)
{
  this.props.handleslink(slink);
}
viewRep()
{ 
  // change this
  window.location.href = "http://surveymate.github.io/analytics/?projectId="+this.props.project.pid;
}
changerlink(rlink)
{
  this.props.handlerlink(rlink);
}
changestep(cstep)
{
  this.props.handlestep(cstep);
}
changestatus(stat)
{
  this.props.handlestatus(stat);
}
  render()
  {
    var st={
      bttn_attri:{
        height:"44px",
        backgroundColor:"#1a84eb",
        border:"none"
      },

    }
    return (
      <div>
          <div >
            <h4 className="pull-left" style={{marginTop:0}}>{this.props.project.projectName}</h4>
          </div>
          <div >
            <button type="button" className="btn btn-info btn-lg pull-right" style={st.bttn_attri} onClick={this.viewRep}>View  Reports</button>
          </div>
          <br />
          <br />
          <br />

          <div>
            <Details data={this.props.project} handlestep={this.changestep} handlestatus={this.changestatus}/>
          </div>
          <div>
            <ActionsBox info={this.props.project} handleslink={this.changeslink} handlerlink={this.changerlink} />
          </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/Home/HomeRight.js
 **/